'use client';

import { twMerge } from 'tailwind-merge';

import { Link, type LinkProps } from '@/components/Link';

import { useMobileNavigation } from '../mobile-navigation-context';

export type SolutionsMenuItemProps = LinkProps;

export function SolutionsMenuItem({
  className,
  ...props
}: SolutionsMenuItemProps) {
  const { onCloseNavigation } = useMobileNavigation();

  function onLinkClick() {
    onCloseNavigation();
  }

  return (
    <Link
      className={twMerge(
        'flex flex-col items-start gap-2 hover:no-underline',
        className,
      )}
      onClick={onLinkClick}
      {...props}
    />
  );
}
